import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoundIcon from './../RoundIcon/RoundIcon';
import style from './style/reportsectionheading.scss';

export default class ReportSectionHeading extends Component {
    render() {
        const {
            title,
            iconType,
            iconText,
            introHeading,
            introHeadingIcon,
            introHeadingAction,
            initials,
            classes
        } = this.props;

        return (
            <div className={ `${style.reportSectionHeading} ${classes.reportSectionHeading}` }>

                { iconType && iconText
                    ? <RoundIcon
                        classes={{
                            root: `${style.roundIcon} ${classes.roundIcon.root}`,
                            roundIconFigureWrapper: classes.roundIcon.roundIconFigureWrapper
                        }}
                        circleSize={ 1.75 }
                        iconSize={ 0.875 }
                        iconType={ iconType }
                        initials={ initials }
                    >
                        <p>{ iconText }</p>
                    </RoundIcon>
                    : null }

                <h3>

                    { title }

                    { introHeading && introHeadingIcon && introHeadingAction
                        ? <FontAwesomeIcon
                            icon={ introHeadingIcon }
                            onClick={ event => {
                                introHeadingAction(event);
                            }}
                        />
                        : null }

                </h3>

            </div>
        );
    }
}

ReportSectionHeading.propTypes = {
    title: PropTypes.string,
    iconType: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    iconText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    introHeading: PropTypes.bool,
    introHeadingIcon: PropTypes.string,
    introHeadingAction: PropTypes.func,
    classes: PropTypes.shape({
        reportSectionHeading: PropTypes.string,
        roundIcon: PropTypes.Object
    })
};

ReportSectionHeading.defaultProps = {
    classes: {
        reportSectionHeading: '',
        roundIcon: {
            root: '',
            roundIconFigureWrapper: ''
        }
    }
};
